import { AnalyticsPropertiesInterface } from '../../interfaces/AnalyticsProperties.interface';

export const ANALYTICS_PAGE_LOAD_EVENT_NAME = 'ScaPageLoad';

export const ANALYTICS_CLICK_EVENT_NAME = 'ScaClickEvent';

export const defaultAnalyticsProperties: AnalyticsPropertiesInterface = {
  Country_Language: 'us|en',
  CustomerType: '',
  ClientId: '',
  Device: '',
  MessageType: '',
  PNL: '',
  PageFunction: 'scaLookup',
  PageKind: 'scaLookup',
  PageName: '',
  PageSubFunction: '',
  Product: '',
  Token: '',
  ExternalCampaignTracking: '',
  InternalCampaignTracking: '',
  OrgChannel: '', // sca-web:dl/qr/el
  ABtest: '',
  SiteIdentifier: 'syfCardAccess',
};
